<template>
  <!-- 多级表头 -->
  <el-table
    :ref="config.ref"
    :data="config.tableData"
    :stripe="config.stripe"
    :height="config.height"
    :border="config.border"
    :max-height="config.maxHeight"
    :size="config.size"
    :fit="config.fit"
    :show-header="config.showHeader"
    :highlight-current-row="config.highlightCurrentRow"
    :current-row-key="config.currentRowKey"
    :row-class-name="config.rowClassName"
    :row-style="config.rowStyle"
    :row-key="customRowkey"
    :empty-text="config.emptyText"
    :default-expand-all="config.defaultExpandAll"
    :[isExpandRowKey]="config.expandRowKeys"
    :default-sort="config.defaultSort"
    :tooltip-effect="config.tooltipEffect"
    :show-summary="config.showSummary"
    :sum-text="config.sumText"
    :indent="config.indent"
    :lazy="config.lazy"
    :cell-class-name="config.cellClassName"
    :cell-style="config.cellStyle"
    :tree-props="config.treeProps"
    :load="loadInfo"
    :summary-method="summaryMethod"
    :span-method="spanMethod"
    @select="handleSelect"
    @select-all="handleSelectAll"
    @selection-change="handleSelectionChange"
    @cell-mouse-enter="cellMouseEnter"
    @cell-mouse-leave="cellMouseLeave"
    @cell-click="cellClick"
    @cell-dblclick="cellDblclick"
    @row-click="rowClick"
    @row-contextmenu="rowContextmenu"
    @row-dblclick="rowDblclick"
    @header-click="headerClick"
    @header-contextmenu="headerContextmenu"
    @sort-change="sortChange"
    @filter-change="filterChange"
    @header-dragend="headerDragend"
    @expand-change="expandChange"
    @current-change="handleCurrentChange"
  >
    <template v-if="$slots.empty" slot="empty">
      <slot name="empty"></slot>
    </template>
    <!-- 插入表格最后一行的内容 -->
    <template v-if="$slots.append" slot="append">
        <slot name="append"></slot>
    </template>
    <template v-for="(elem, index) in config.column">
      <!-- 自定义列 -->
      <slot v-if="elem.slotName" :name="elem.slotName"></slot>

      <template  v-else>
        <!-- 多选 -->
        <template v-if="elem.type == 'selection'">
          <el-table-column type="selection" width="55" :key="elem+index"></el-table-column>
        </template>
        <!-- 序号 -->
        <template v-else-if="elem.type == 'index'">
          <el-table-column :key="elem+index"  type="index" :label="elem.label" :index="indexMethod" width="55">
          </el-table-column>
        </template>
        <!-- 展开行 -->
        <el-table-column  :key="elem+index+1" v-else-if="elem.type == 'expand'" type="expand" width="55">
          <template slot-scope="props">
            <slot :props="props.row"></slot>
          </template>
        </el-table-column>
        <template v-else>
            <!-- 行数据 -->
          <el-table-column
            :key="index"
            :type="config.type"
            :column-key="config.columnKey"
            :prop="elem.prop"
            :label="elem.label"
            :width="elem.width"
            :min-width="elem.minWidth"
            :fixed="elem.fixed"
            :sortable="elem.sortable"
            :sort-by="elem.sortBy"
            :sort-orders="elem.sortOrders"
            :resizable="elem.resizable"
            :show-overflow-tooltip="elem.showOverflowTooltip"
            :align="elem.align"
            :header-align="elem.headerAlign"
            :class-name="elem.className"
            :label-class-name="elem.labelClassName"
            :reserve-selection="elem.reserveSelection"
            :[elem.cunstomHeaderLabel]="slotHeader"
            :sort-method="sort"
            :selectable="handleSelectable"
          >
            <!-- 自定义列内容 -->
              <template :slot="elem.isCustomizeColumn?'default':''" v-if="$slots[elem.customColumnName] || $scopedSlots[elem.customColumnName]" slot-scope="{ row, column, $index }">
                  <slot :name="elem.customColumnName" :row="row" :column="column" :$index="$index"></slot>
              </template>
            <!-- 自定义头部 -->
            <template :slot="elem.isCustomizeHeader?'header':''" v-if="$slots[elem.customColumnHeaderName] || $scopedSlots[elem.customColumnHeaderName]" slot-scope="{ column, $index }">
                <slot :name="elem.customColumnHeaderName" :column="column" :$index="$index"></slot>
            </template>
          </el-table-column>
        </template>
        
      </template>
      <!-- 空数据时显示的文本内容 -->
    </template>
    
  </el-table>
</template>
<script>
export default {
  data() {
    return {};
  },

  props: {
    config: {
      require: true,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    //根据config返回的rowKey来判断是否展开行
    isExpandRowKey() {
      return !!this.config.rowKey ? "expand-row-keys" : "testKey";
    },
  },
  watch: {},
  created() {
    console.log(this)
  },
  methods: {
    //自定义label
    slotHeader(h, columnInfo) {
      this.$emit("render-header", h, columnInfo);
    },
    sort(a, b) {
      this.$emit("sort-method", a, b);
    },
    //选中表格行
    handleCurrentChange(currentRow, oldCurrentRow) {
      this.$emit("current-change", currentRow, oldCurrentRow);
    },
    //自定义合计算法
    summaryMethod(params) {
      this.$emit("summary-method", params);
    },
    //合并行或列计算法
    spanMethod(params) {
      this.$emit("span-method", params);
    },
    //加载子节点函数
    loadInfo(row, treeNode, resolve) {
      this.$emit("load", row, treeNode, resolve);
    },
    //当用户手动勾选数据行的 Checkbox 时触发的事件
    handleSelect(selection, row) {
      this.$emit("select", selection, row);
    },
    //当用户手动勾选全选 Checkbox 时触发的事件
    handleSelectAll(selection) {
      this.$emit("select-all", selection);
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.$emit("selectionChange", selection);
    },
    //当单元格 hover 进入时会触发该事件
    cellMouseEnter(row, column, cell, event) {
      this.$emit("cell-mouse-enter", row, column, cell, event);
    },
    //当单元格 hover 退出时会触发该事件
    cellMouseLeave(row, column, cell, event) {
      this.$emit("cell-mouse-leave", row, column, cell, event);
    },
    //当某个单元格被点击时会触发该事件
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    //当某个单元格被双击击时会触发该事件
    cellDblclick(row, column, cell, event) {
      this.$emit("cell-dblclick", row, column, cell, event);
    },
    //当某一行被点击时会触发该事件
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    //当某一行被鼠标右键点击时会触发该事件
    rowContextmenu(row, column, event) {
      this.$emit("row-contextmenu", row, column, event);
    },
    //当某一行被双击时会触发该事件
    rowDblclick(row, column, event) {
      this.$emit("row-dblclick", row, column, event);
    },
    //当某一列的表头被点击时会触发该事件
    headerClick(column, event) {
      this.$emit("header-click", column, event);
    },
    //当某一列的表头被鼠标右键点击时触发该事件
    headerContextmenu(column, event) {
      this.$emit("header-contextmenu", column, event);
    },
    //当表格的排序条件发生变化的时候会触发该事件
    sortChange(selection) {
      this.$emit("sort-change", selection);
    },
    //当表格的筛选条件发生变化的时候会触发该事件，参数的值是一个对象，对象的 key 是 column 的 columnKey，对应的 value 为用户选择的筛选条件的数组
    filterChange(selection) {
      this.$emit("filter-change", selection);
    },
    //当拖动表头改变了列的宽度的时候会触发该事件
    headerDragend(newWidth, oldWidth, column, event) {
      this.$emit("header-dragend", newWidth, oldWidth, column, event);
    },
    //当用户对某一行展开或者关闭的时候会触发该事件（展开行时，回调的第二个参数为 expandedRows；树形表格时第二参数为 expanded）
    expandChange(row, expandedRows) {
      this.$emit("expand-change", row, expandedRows);
    },
    //自定义索引
    indexMethod(index) {
      try {
        return this.$parent.modifyIndex?this.$parent.modifyIndex(index) : index+1
      } catch (error) {
        console.log(error)
      }
    },
    //自定义rowkey
    customRowkey(row) {
      try {
        return this.$parent.modifyRowkey?this.$parent.modifyRowkey(row) : row?.id
      } catch (error) {
        console.log(error)
      }
    },
    //用来格式化内容
    handleFormatter(row, column, cellValue, index) {
      this.$emit("formatter", row, column, cellValue, index);
    },
    //仅对 type=selection 的列有效，类型为 Function，Function 的返回值用来决定这一行的 CheckBox 是否可以勾选
    handleSelectable(row, index) {
      this.$emit("selectable", row, index);
    },
  },
};
</script>

<style lang="scss" scoped></style>
